import { Button, Input, makeStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import UtilService from "../../../../../../helper/service";

const useStyles = makeStyles(() => ({
  title: {
    minWidth: 100,
    background: '#fff',
    padding: '9px 12px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    marginLeft: -4,
    marginTop: 17,
    cursor: 'context-menu',
  },
  box: {
    width: 550,
    zIndex: 1000,
    background: '#fff',
    padding: 24,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    borderRadius: 12,
    '@media screen and (max-width: 600px)': {
      width: '100%',
    }
  },
  postBtn: {
    width: 72,
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: 'white',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0d77d4',
    },
  },
  dFlex: {
    display: 'flex'
  },
  annoInput: {
    marginRight: 16,
    padding: '1px 14px',
    borderRadius: 6,
    background: '#F2F2F2',
    fontFamily: 'roboto-regular',
    fontSize: 16,
    color: '#697683',
    '@media screen and (max-width: 600px)': {
      fontSize: 13,
    }
  },
  annoHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#4F5F6E'
  },
  annoNotification: {
    display: 'flex',
    flex: 1,
    marginRight: 8,
    alignItems: 'center'
  },
  annoHeaderGreen: {
    color: '#1DB859'
  },
  annoCancel: {
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 14,
    marginLeft: 18,
    cursor: 'pointer'
  },
  annoClose: {
    cursor: 'pointer'
  },
  mr4px: {
    marginRight: 4
  }
}));

const LiveAnnotation = forwardRef((props: any, ref: any) => {

  LiveAnnotation.displayName = 'LiveAnnotation'

  const {
    onAddNote,
    onCloseBox,
    sessionType,
    analyseStart
  } = props;

  const classes = useStyles();

  const [annoTime, setAnnoTime] = useState(0);
  const [curTime, setCurTime] = useState(0);
  const [annotation, setAnnotation] = useState('');
  const [enablePost, setEnablePost] = useState(true);

  let interval: any;
  const textInput: any = useRef();

  const onKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!UtilService.isEmpty(annotation))
        onPostAnnotation();
    }
  }

  const onAnnoInputChange = (e: any) => {
    if (annoTime === 0) {
      interval = setInterval(() => {
        setCurTime(Math.floor(new Date().getTime() - 10000));
      }, 1000);

      setAnnoTime(Math.floor(new Date().getTime() - 10000));
      setCurTime(Math.floor(new Date().getTime() - 10000));
    }

    setAnnotation(e.target.value);
  }

  const cancelAnnotation = () => {
    if (interval)
      clearInterval(interval);
    setAnnoTime(0);
    setAnnotation('');
    focusInput();
  }
  const focusInput = () => {
    if (!textInput.current) return;
    textInput.current.focus();
    setEnablePost(true);
  }

  useImperativeHandle(
    ref,
    () => ({
      onFocusInput() {
        setEnablePost(false);
        focusInput();
      }
    }),
  )

  const onPostAnnotation = () => {
    if (!enablePost) return;
    onAddNote(sessionType === 'ASYNC' ? Math.floor(analyseStart) : Math.floor(annoTime / 1000), annotation);
    cancelAnnotation();
  }

  return (
    <div className={classes.box}>
      <div className={classes.annoHeader}>
        <span> <img src={(annoTime === 0) ? '/assets/icons/liveanalysis/icon-location.svg' : '/assets/icons/liveanalysis/icon-marker.svg'} alt={'img'} className={classes.mr4px} /> </span>
        <span className={classes.annoNotification}>
          <span className={(annoTime === 0) ? '' : classes.annoHeaderGreen}>{annoTime === 0 ? "What's happening right now?" : `This annotation began ${(Math.floor((curTime - annoTime) / 1000))} seconds ago`}</span>
          {(annoTime > 0) &&
            <span
              className={classes.annoCancel}
              onClick={() => cancelAnnotation()}>
              Cancel
            </span>
          }
        </span>

        <CloseIcon
          className={classes.annoClose}
          onClick={() => {
            cancelAnnotation();
            onCloseBox();
          }}
        />

      </div>

      <div className={classes.dFlex}>
        <Input
          id='input_annotation'
          inputRef={textInput}
          autoFocus
          placeholder="Start typing to annotate the timeline…"
          className={classes.annoInput}
          disableUnderline
          fullWidth
          value={annotation}
          inputProps={{
            'aria-label': 'Post'
          }}
          onChange={(e) => onAnnoInputChange(e)}
          onKeyPress={(e) => onKeyPress(e)}
        />
        <Button
          variant="contained"
          color="secondary"
          className={classes.postBtn}
          onClick={() => onPostAnnotation()}
        >
          Post
        </Button>
      </div>
    </div>
  )
})

export default LiveAnnotation;